/** cart.guest.type member is probably also REGISTERED */
export function isRegisteredUserType(userType) {
  return !["CONTRACT", "TRADE", "ANONYMOUS", "GUEST"].includes(
    (userType || "").toUpperCase() ?? ""
  );
}

export const shouldShowUserInitials = (
  firstName: string | undefined | null,
  lastName: string | undefined | null,
  userType: string | undefined | null
): boolean => {
  return (
    !!(firstName || lastName) &&
    userType !== "GUEST" &&
    userType !== "ANONYMOUS"
  );
};
